<template>
	<g clip-path="url(#icon-embed-player-mode-clip0)">
		<path
			d="M1 9.4C1 12.0399 1 13.3598 2.02513 14.1799C3.05025 15 4.70017 15 8 15C11.2998 15 12.9497 15 13.9749 14.1799C15 13.3598 15 12.0399 15 9.4V6.6C15 3.96013 15 2.6402 13.9749 1.8201C12.9497 1 11.2998 1 8 1C4.70017 1 3.05025 1 2.02513 1.8201C1 2.6402 1 3.96013 1 6.6V9.4Z"
			stroke="currentColor" stroke-width="1.2" />
		<path
			d="M11 8C11 7.36664 10.338 6.9395 9.01396 6.08521C7.67186 5.21925 7.0008 4.78628 6.5004 5.10419C6 5.42209 6 6.2814 6 8C6 9.7186 6 10.5779 6.5004 10.8958C7.0008 11.2137 7.67186 10.7807 9.01396 9.91479C10.338 9.0605 11 8.63336 11 8Z"
			stroke="currentColor" stroke-width="1.2" />
	</g>
	<defs>
		<clipPath id="icon-embed-player-mode-clip0">
			<rect width="16" height="16" fill="white" />
		</clipPath>
	</defs>
</template>
